import React from 'react';
import Colors from '../utils/colors';

const PrivacyPolicy = () => {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Vehicle Tax Buddy - Privacy Policy</h1>
        <p style={styles.lastUpdated}>Last updated: January 2024</p>
      </div>
      
      <div style={styles.content}>
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>Information We Collect</h2>
          <p style={styles.text}>
            Vehicle Tax Buddy collects information you provide directly to us, such as when you create an account, 
            make a payment, or contact us for support. This may include your name, email address, 
            phone number, and vehicle information.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>How We Use Your Information</h2>
          <p style={styles.text}>
            Vehicle Tax Buddy uses the information we collect to provide, maintain, and improve our services, 
            process transactions, send you technical notices and support messages, and communicate 
            with you about products, services, and promotional offers.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>Information Sharing</h2>
          <p style={styles.text}>
            Vehicle Tax Buddy does not sell, trade, or otherwise transfer your personal information to third parties 
            without your consent, except as described in this policy. We may share information with 
            trusted service providers who assist us in operating our platform.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>Data Security</h2>
          <p style={styles.text}>
            Vehicle Tax Buddy implements appropriate security measures to protect your personal information against 
            unauthorized access, alteration, disclosure, or destruction. However, no method of 
            transmission over the internet is 100% secure.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>Contact Us</h2>
          <p style={styles.text}>
            If you have any questions about this Privacy Policy, please contact us at {' '}
            <a href="mailto:support@vehicletaxbuddy.com" style={styles.email}>support@vehicletaxbuddy.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

const styles = {
  container: {
    background: Colors.gradientBackground,
    minHeight: '100vh',
    padding: '40px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  header: {
    background: Colors.white,
    maxWidth: '900px',
    margin: '0 auto 30px',
    padding: '40px',
    borderRadius: '16px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
    textAlign: 'center'
  },
  title: {
    fontSize: '3rem',
    color: Colors.primary,
    margin: '0 0 15px 0',
    fontWeight: '700'
  },
  lastUpdated: {
    color: Colors.gray,
    fontSize: '1rem',
    margin: 0
  },
  content: {
    maxWidth: '900px',
    margin: '0 auto'
  },
  section: {
    background: Colors.white,
    marginBottom: '24px',
    padding: '32px',
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    border: 'none'
  },
  sectionTitle: {
    fontSize: '1.75rem',
    color: Colors.primary,
    marginBottom: '20px',
    fontWeight: '600',
    borderLeft: `4px solid ${Colors.secondary}`,
    paddingLeft: '16px'
  },
  text: {
    fontSize: '1.1rem',
    color: Colors.darkGray,
    margin: 0,
    lineHeight: '1.8'
  },
  email: {
    color: Colors.blue,
    fontWeight: '600',
    textDecoration: 'none'
  }
};

export default PrivacyPolicy;